/* eslint-disable jsx-a11y/anchor-is-valid */
import React,{useEffect,useState} from 'react'
import { useParams } from "react-router-dom";
import {InvoiceExpandDetails} from "../InvoiceExpandDetails"
import {
    Paper,
    Tabs,
    Tab,
    Typography,
    makeStyles,
    Snackbar,
    SnackbarContent,
} from "@material-ui/core";
import clsx from "clsx";
import green from "material-ui/colors/green";
import PropTypes from "prop-types";
import { NODE_API_URL,BASE_URL } from '../../../../env_config';
import axios from 'axios';
import InvoiceDetailSkeleton from '../InvoiceDetailSkeleton';
import { BsArrowLeftShort } from "react-icons/bs";
import moment from "moment-timezone";
import { MdOutlineEmail } from "react-icons/md";
import { FaRegFilePdf } from 'react-icons/fa6';
import Cookies from "js-cookie";
import getSymbolFromCurrency from 'currency-symbol-map';
  function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
  }
  
  TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
  };

export const InviceDetail = (props) => {
    const [value, setValue] = React.useState(0); // for tab
    const [data,setData] = React.useState([])
    const [invData,setInvData] = React.useState(null)
    const [stoneData, setStoneData] = React.useState();
    const {OrderId} = useParams()
    // console.log("OrderId",OrderId)
    function handleTabChange(event, newValue) {
        setValue(newValue);
    }
    const [cgst,setCGST] = useState(0)
    const [sgst,setSGST] = useState(0)
    const [tax,setTAX] = useState(0)
    const [chargetax,setChargeTax] = useState(0)
    const [alertOpen, setAlertOpen] = React.useState(false);
    const [alertMessage, setAlertMessage] = React.useState();
    function handleClose(event, reason) {
        setAlertOpen(false);
    }
  
    const useStyles = makeStyles((theme) => ({
        success: {
            backgroundColor: green[600],
        },
        
    }));
  
    function MySnackbarContentWrapper(props) {
        const classes = useStyles();
        const { className, message, onClose, variant, ...other } = props;
  
        return (
            <SnackbarContent
                className={clsx(classes[variant], className)}
                aria-describedby="client-snackbar"
                message={
                    <span id="client-snackbar" className={classes.message}>
                        {message}
                    </span>
                }
                {...other}
            />
        );
    }
    useEffect(() => {
        
        const finalData = { 
            "order_id":OrderId
        }
        axios({
            method: "get",
            url: `${NODE_API_URL}/INTL/get-invoice-details`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            },
            params:finalData
        }).then((res) => {
            if (res && res.data) {
                setInvData(res.data)
                setStoneData(res.data.expand)

            }
        }).catch(error => {
            if(error?.response?.data?.message === "UnAuthorized!"){
                var cookies = document.cookie.split(";");
              for (var i = 0; i < cookies.length; i++) {
                if(cookies[i] && !cookies[i].includes("view")){
                  var equals = cookies[i].indexOf("=");
                  var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                  document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                }
              }
              
              window.location.replace(`${BASE_URL}/logout`);
            }
        })
    },[])
    function numberWithCommas(x) {
        if(x){
        return x?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        }
    }
    const GetPDF = () => {
        window.open(invData.pdf_link, "_blank")
    }
    const SendEmail = () => {
        const finalData = {
            "order_id":OrderId,
            "conform_good_id":invData.confirmGoodsId.split(','),
            "client_id":props.userinfo.id
        }
        let apilink = "https://api.immitation.diamondsupload.com"
        if(process.env.REACT_APP_ENV === "production"){
            apilink = "https://api.oasis.diamondsoncall.online"
        }
        axios({
            method: "POST",
            url: `${apilink}/admin/invoicemail`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            },
            data:finalData
        }).then(res => {
            if(res && res.data && res.invData.success){
                setAlertMessage(res.invData.message)
                if(res.data){
                    setAlertOpen(true)
                    // alert(res.data)
                }
            }
        }).catch(error => {
            if(error?.response?.data?.message === "UnAuthorized!"){
                var cookies = document.cookie.split(";");
              for (var i = 0; i < cookies.length; i++) {
                if(cookies[i] && !cookies[i].includes("view")){
                  var equals = cookies[i].indexOf("=");
                  var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                  document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                }
              }
              
              window.location.replace(`${BASE_URL}/logout`);
            }
        })
    }
    const TrackOrder = (invoicedata) => {
        window.open(invData?.tracking_link)
    }
    const getaddress = () => {
        let shippingaddress = ""
        let billingaddress = ""
        if(invData){
            if(invData.company_name_official){
                shippingaddress += "<p><b>"
                shippingaddress += invData.company_name_official
                shippingaddress += "</b></p>"
            }
            if(invData?.name_atten){
                shippingaddress += "<p><b>"
                shippingaddress += invData?.name_atten
                shippingaddress += "</b></p>"
            }
            if(invData?.shipping_address_1){
              shippingaddress += "<p>"
              shippingaddress += invData?.shipping_address_1 + ","
              shippingaddress += "</p>"
            }
            if(invData?.shipping_address_2){
                shippingaddress += "<p>"
                shippingaddress += invData?.shipping_address_2 + ","
                shippingaddress += "</p>"
            }
            if(invData?.shipping_address_3){
                shippingaddress += "<p>"
                shippingaddress += invData?.shipping_address_3 + ","
                shippingaddress += "</p>"
            }
            shippingaddress += "<p>"
            shippingaddress += invData?.shipping_city + ", "
            if(invData?.shipping_state){
                shippingaddress += invData?.shipping_state + ", "
            }
            if(invData?.shipping_zip_code){
                shippingaddress += invData?.shipping_zip_code + ", "
            }
            shippingaddress += "</p>"
            if(invData?.shipping_country){
                shippingaddress += "<p>"
                shippingaddress += invData?.shipping_country
                shippingaddress += "</p>"
            }
            if(invData?.fedex_ac_no){
                shippingaddress += "<p>Fedex Ac No:"
                shippingaddress += invData?.fedex_ac_no
                shippingaddress += "</p>"
            }
            if(invData?.shipping_email){
                shippingaddress += "<p>Email:"
                shippingaddress += invData?.shipping_email
                shippingaddress += "</p>"
            }
            if(invData?.shipping_phone){
                shippingaddress += "<p>Phone:"
                shippingaddress += invData?.shipping_phone
                shippingaddress += "</p>"
            }
        
            
        
            if(invData.company_name_official){
                billingaddress += "<p><b>"
                billingaddress += invData.company_name_official
                billingaddress += "</b></p>"
            }
            if(invData.address){
              billingaddress += "<p>"
              billingaddress += invData.address + ","
              billingaddress += "</p>"
            }
            if(invData.secaddress){
                billingaddress += "<p>"
                billingaddress += invData.secaddress + ","
                billingaddress += "</p>"
            }
            if(invData.addressline3){
                billingaddress += "<p>"
                billingaddress += invData.addressline3 + ","
                billingaddress += "</p>"
            }
            billingaddress += "<p>"
            billingaddress += invData?.city + ", "
            if(invData?.state){
                billingaddress += invData?.state + ", "
            }
            if(invData?.com_zip){
                billingaddress += invData?.com_zip + ","
            }
            billingaddress += "</p>"
            if(invData.country){
                billingaddress += "<p>"
                billingaddress += invData.country
                billingaddress += "</p>"
            }
            if(invData.company_tax){
                billingaddress += `<p><b>${invData.company_tax_name}:</b>`
                billingaddress += invData.company_tax
                billingaddress += "</p>"
            }
            if(invData.com_reg_no){
                billingaddress += `<p><b>${invData.com_reg_no_name}:</b>`
                billingaddress += invData.com_reg_no
                billingaddress += "</p>"
            }
        }
        return{
            shippingaddress:shippingaddress,
            billingaddress:billingaddress
        }
}
    return (
        <>
        {invData?
           <>
           <div className="row bg-white m-0 rounded border-left-primary mb-5">
               <div className="col-12 px-5 py-2">
                   <div className="mb-0 font-size-h3 font-weight-bold d-block tex-dark"> {props.language.PROFORMA_DETAIL_DOCLLP} </div>
                   {/* <div className="text-muted">{props.language.INVOICE_DETAIL_GSTIN} 27AASFD2652D1ZF</div > */}
                   <div className="text-muted">{invData?.docaddress?.split('\n').map((line, index) => (
                               <span key={index}>
                                   {line}
                                   <br />
                               </span>
                               ))}</div >
               </div>
           </div>
           <div className="card custom-card border-0 gutter-b">
               <div className="card-header bg-transparent  py-3 px-5 d-flex justify-content-between align-items-center border-bottom-0">
                   <div className="card-title mb-0 ">
                       <span className="font-size-h3 font-weight-bold d-block">{props.language.INVOICE_DETAIL_INVOICE_DETAIL}: #{invData.invoiceCountry === "IND-EXP"?invData.export_no:invData.invoicenumber} {invData.invoiceCountry === "IND-EXP"?"(Shipment From India)":""}</span>
                       <span className="text-muted d-block">
                           {props.language.INVOICE_DETAIL_INVOICED_ON}
                           {/* {invData.invoiceDate} */}{" "}
                           { invData.invoiceDate ? moment.tz(invData.invoiceDate, props.userinfo.timezone ? props.userinfo.timezone : Intl.DateTimeFormat().resolvedOptions().timeZone).format("YYYY-MM-DD HH:mm:ss") : "-"}
                           </span >
                   </div>
                   <div className="card-toolbar">
                       <span className="btn btn-text-dark btn-hover-light-dark  mr-3"onClick={() =>window.history.go(-1)}><BsArrowLeftShort className='mr-2 font-size-h5'/> {props.language.BACK}</span>
                       <button className="btn btn-text-dark btn-hover-light-primary  mr-3" onClick={SendEmail}><MdOutlineEmail className='mr-2 font-size-h5'/>{props.language.PROFORMA_DETAIL_SEND_EMAIL}</button>
                       <button className="btn btn-text-dark btn-hover-light-danger " onClick={GetPDF}><FaRegFilePdf className='mr-2 font-size-h5'/>{props.language.PROFORMA_DETAIL_SEND_PDF}</button>
                   </div>
               </div>
               <div className="card-body rounded p-0 bg-white pb-8">
                   <Paper position="static" className="shadow-none bg-transparent border-bottom">
                       <Tabs value={value} indicatorColor="primary" textColor="primary" onChange={handleTabChange}>
                           <Tab label={props.language.PROFORMA_DETAIL_DETAILS} />
                           {/* <Tab label="History" disabled /> */}
                           {/* <Tab label="Additional Details"/> */}
                       </Tabs>
                   </Paper>
                    {value === 0 && (
                       <TabContainer >
                           <div className="row">
                               <div className="col-md-3">
                                   <div className="font-size-h4 font-weight-bold mb-2">{props.language.PROFORMA_DETAIL_SHIPPING_ADDRESS}</div>
                                   <div>
                                   {getaddress().shippingaddress ?  <div className="invAddress" dangerouslySetInnerHTML={ {__html:  getaddress().shippingaddress} } />: '-'}
                                   </div>
                               </div>
                               <div className="col-md-3">
                                   <div className="font-size-h4 font-weight-bold  mb-2">{props.language.PROFORMA_DETAIL_BILLING_ADDRESS}</div>
                                   <div>
                                   {getaddress().billingaddress?  <div className="invAddress" dangerouslySetInnerHTML={ {__html:  getaddress().billingaddress} } />:  '-'}
                                   </div>
                               </div>
                               <div className="col-md-3">
                                   <div className="font-size-h4 font-weight-bold mb-2">{props.language.PROFORMA_DETAIL_LOGISTICS_INFORMATION}</div>
                                   <div className=""> {invData.shippingName ? invData.shippingName : null} </div>
                                   {invData.tracking_no?<div>Track Your Package: <a onClick={() => TrackOrder()} target="_blank" rel='referal' href='#'>{invData.tracking_no}</a></div>:""}
                                   {/* <a href='#' target="_blank" rel='referal'>Track Your Package</a> */}
                               </div>
                               <div className="col-md-3">
                                   <div className="font-size-h4 font-weight-bold mb-2">{props.language.PROFORMA_DETAIL_ORDER_SUMMARY}</div>
                                   <div className="row">
                                       <div className="col-12 d-flex justify-content-between">
                                           <span>{props.language.PROFORMA_DETAIL_DIAMONDS}:</span>
                                           <span> {invData.totalDiamondCount ? invData.totalDiamondCount : null} {props.language.PROFORMA_DETAIL_PCS}</span>
                                       </div>
                                       <div className="col-12 d-flex justify-content-between">
                                           <span>{props.language.SEARCHLIST_TOTALCARAT}:</span>
                                           <span>{invData.totalCarat ? invData.totalCarat : null}</span>
                                       </div>
                                       <div className="col-12 d-flex justify-content-between">
                                           <span>{props.language.SEARCHGRID_TOTAL} {invData["totalDiamondPriceSymbolName"]}/CT:</span>
                                           <span>{invData["totalDiamondPriceSymbol"]}{numberWithCommas(parseFloat(invData["totalDiamondRate"]))}</span>
                                       </div>
                                       <div className="col-12 d-flex justify-content-between">
                                           <span>{props.language.INVOICE_DETAIL_TOTAL_PRICE} {invData["totalDiamondPriceSymbolName"]}:</span>
                                           <span>{invData["totalDiamondPriceSymbol"]}{numberWithCommas(parseFloat(invData.totalDiamondPrice))}</span>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </TabContainer>
                   )}
                   {/* {value === 1 && (
                       <TabContainer >
                           2
                       </TabContainer>
                   )} */}
               </div>
           </div>
           <div className="card custom-card border-0 gutter-b">
               <div className="card-header bg-transparent py-5 border-bottom-0">
                   <div className="card-title mb-0 font-weight-bold font-size-h4 ">{props.language.PROFORMA_DETAIL_DIAMONDS_INFORMATION}</div>
               </div>
               <div className="card-body p-8 rounded bg-white">
                  {stoneData ? <InvoiceExpandDetails diamonddetail={stoneData} userinfo={props.userinfo} language={props.language} expandData={invData}/> : null }
                   <div className="row p-5 mt-5">
                       <div className="col-md-7">
                           {/* <div className="font-size-h4  mb-2">NOTES</div>
                           <div>
                               Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                           </div> */}
                       </div>
                       <div className="col-md-5">
                       <table className='table'>
                           <tr>
                               <td className="font-size-h5">{props.language.INVOICE_DIAMOND_PRICE}:</td>
                               <td className="font-size-h5 text-right">
                               {invData["totalDiamondPriceSymbol"]}{numberWithCommas(parseFloat(invData.totalDiamondPrice))}
                                   <div className='small text-muted'>{invData["totalDiamondPriceSymbol"]}/CT{invData["totalDiamondRate"] ? numberWithCommas(parseFloat( invData["totalDiamondRate"])) : null}</div>
                               </td>
                               {invData.displayExchange ?
                                   <td className="font-size-h5 text-right">
                                      { invData.totalDiamondExchangePriceSymbol}{numberWithCommas(parseFloat(invData.totalDiamondExchangePrice))}
                                       <div className='small text-muted'>{invData.totalDiamondExchangePriceSymbol}/CT {invData["totalDiamondExchangeRate"] ? numberWithCommas(parseFloat( invData["totalDiamondExchangeRate"])) : null}</div>
                                   </td>
                               :null}
                           </tr>
                           {invData.extraChargesOrDiscount?
                           <tr>
                               <td className="font-size-h5">{invData.extraChargesOrDiscount>0?props.language.INVOICE_EXTRA_CHARGES:props.language.INVOICE_DISCOUNT}:</td>
                               <td className="font-size-h5 text-right">{invData["totalDiamondPriceSymbol"]}{numberWithCommas(invData.extraChargesOrDiscount)}</td>
                               {invData.displayExchange ?
                                   <td className="font-size-h5 text-right">{ invData.totalDiamondExchangePriceSymbol}{numberWithCommas(invData.extraChargesOrDiscountExchange)}</td>
                               :null}
                           </tr>:null}
                           {invData.shippingCharge?<tr className="">
                               <td className="font-size-h5">{invData.invoiceCountry === "IND-EXP"?"Shipping Charges":props.language.REQ_DIAMOND_CONVINIENCE_FEE}:</td>
                               <td className="font-size-h5  text-right">{invData["totalDiamondPriceSymbol"]}{numberWithCommas(invData.shippingCharge)}</td>
                               {invData.displayExchange ?
                                   <td className="font-size-h5  text-right">{ invData.totalDiamondExchangePriceSymbol}{numberWithCommas(invData.shippingChargeExchange ? invData.shippingChargeExchange:"00")}</td>
                               :null}
                           </tr>:""}
                           {invData.indiacgst?<tr>
                               <td className="font-weight-bold font-size-h5">CGST({invData.indiacgstrate})</td>
                               <td className="font-weight-bold  text-right font-size-h5">{invData.totalDiamondPriceSymbol}{numberWithCommas(invData.indiacgst)}</td>
                           </tr>:""}
                           {invData.indiasgst?<tr>
                               <td className="font-weight-bold font-size-h5">SGST({invData.indiasgstrate})</td>
                               <td className="font-weight-bold  text-right font-size-h5">{invData.totalDiamondPriceSymbol}{numberWithCommas(invData.indiasgst)}</td>
                           </tr>:""}
                           {invData.indiaigst?<tr>
                               <td className="font-weight-bold font-size-h5">IGST({invData.indiaigstrate})</td>
                               <td className="font-weight-bold  text-right font-size-h5">{invData.totalDiamondPriceSymbol}{numberWithCommas(invData.indiaigst)}</td>
                           </tr>:""}
                           {invData.chargetax?<tr>
                               <td className="font-weight-bold font-size-h5">Charge Tax({invData.chargetaxrate})</td>
                               <td className="font-weight-bold  text-right font-size-h5">{invData.totalDiamondPriceSymbol}{numberWithCommas(invData.chargetax)}</td>
                           </tr>:""}
                           {invData.australiagst?<tr>
                               <td className="font-weight-bold font-size-h5">GST({invData.australiagstrate})</td>
                               <td className="font-weight-bold  text-right font-size-h5">{invData.totalDiamondPriceSymbol}{numberWithCommas(invData.australiagst)}</td>
                           </tr>:""}
                           <tr>
                               <td className="font-weight-bold font-size-h5">{props.language.REQ_TOTAL_DIAMOND_PRICE}</td>
                               <td className="font-weight-bold  text-right font-size-h5">{invData["totalDiamondPriceSymbol"]}{numberWithCommas(parseFloat(invData["totalDiamondPriceInvoice"]))}</td>
                               {invData.displayExchange ?
                                   <td className="font-weight-bold  text-right font-size-h5">{ invData.totalDiamondExchangePriceSymbol}{numberWithCommas(parseFloat(invData["totalDiamondPriceInvoiceExchange"]))}</td>
                               :null}
                           </tr>
                           {invData.creditCardCharge?<tr>
                               <td className="font-weight-bold font-size-h5">{props.language.INVOICE_CREDIT_CARD_CHARGES}</td>
                               <td className="font-weight-bold  text-right font-size-h5">{invData.totalDiamondPriceSymbol}{numberWithCommas(invData.creditCardCharge)}</td>
                           </tr>:""}
                       </table>
                       </div>
                   </div>
               </div>
           </div>
           <div className="card bg-white">
           <div className="card-body">
               {invData?.bankdetails || invData?.bankdetailsother ?
                   <div className="row">
                   {invData?.bankdetails?<div className="col">
                       <div className="font-size-h4 font-weight-bold mb-2">{invData?.bankheader}</div>
                       <div className="font-size-lg">
                           {invData?.bankdetails.split('\n').map((line, index) => (
                               <span key={index}>
                                   {line}
                                   <br />
                               </span>
                               ))}
                       </div>
                   </div >:""}
                   {invData?.bankdetailsother?<div className="col">
                       <div className="font-size-h4 font-weight-bold mb-2">{invData?.bankheaderother}</div>
                       <div className="font-size-lg">
                           {invData?.bankdetailsother.split('\n').map((line, index) => (
                               <span key={index}>
                                   {line}
                                   <br />
                               </span>
                               ))}
                       </div>
                   </div >:""}
                   <div className="col">
                               <div className="font-size-h4 font-weight-bold mb-3">Declaration :</div>
                               <div className="font-size-lg mb-3">
                                   1) We Declare that this Invoice shows the actual price of the goods described and that all particulars are true and correct.
                               </div>
                               <div className="font-size-lg mb-3">
                                   2) The diamonds herein invoiced have been purchased from legitimate sources not involved in funding conflict and in compliance with United Nations Resolutions.
                               </div>
                               <div className="font-size-lg mb-3">
                                   3) The seller hereby guarantees that these diamonds are conflict free based on personal knowledge and/or written guarantees provided by supplier of these diamonds.
                               </div>
                           </div>
               </div >
               :
               <>
                   {invData?.paymentMethod === "Credit Card Payment"?<div className="row">
                           <div className="col-md-4">
                               <div className="font-size-h4 font-weight-bold mb-2">{props.language.INVOICE_DETAIL_PAYMENT_METHOD}</div>
                               <div className='font-size-lg'>
                                   <div>{invData.paymentMethod}</div>
                               </div>
                           </div >
                           <div className="col-md-8">
                               <div className="font-size-h4 font-weight-bold mb-3">Declaration :</div>
                               <div className="font-size-lg mb-3">
                                   1) We Declare that this Invoice shows the actual price of the goods described and that all particulars are true and correct.
                               </div>
                               <div className="font-size-lg mb-3">
                                   2) The diamonds herein invoiced have been purchased from legitimate sources not involved in funding conflict and in compliance with United Nations Resolutions.
                               </div>
                               <div className="font-size-lg mb-3">
                                   3) The seller hereby guarantees that these diamonds are conflict free based on personal knowledge and/or written guarantees provided by supplier of these diamonds.
                               </div>
                           </div>
                   </div >: ""}
                   </>
               }
           </div>
       </div>
       </>
           : <InvoiceDetailSkeleton /> } 
            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                open={alertOpen}
                autoHideDuration={2000}
                onClose={handleClose}
            >
                <MySnackbarContentWrapper
                    onClose={handleClose}
                    variant="success"
                    message={alertMessage}
                />
            </Snackbar>
        </>
    )
}